<template>
  <transition name="fade" appear>
    <div :class="{'c-popup':true, 'c-popup--vertical': modalPositionVertical}" v-show="modal">
      <div class="c-popup__bg"></div>
      <div class="c-popup__inner">
        <div :class="{'closeLayer':true, '-slowly-display':workStore.isBreakTimeModal}" @click="emit('close-layer')"></div>
        <div :class="{'c-popup-body':true, ['-'+subject]:!!subject, '-break':workStore.isBreakTimeModal}">
          <div class="c-popup-body__overwrap">
            <div class="c-popup-body__label">
              <slot name="label"></slot>
            </div>
            <span class="c-popup-body__close" @click="emit('close')" :name="name">
              <span class="c-popup-body__close-inner"></span>
            </span>
            <div class="c-popup-body__inner">
              <div :class="{'c-popup-body__main': true, '-no-scroll': isNextGradeModal}">
                <slot name="main"></slot>
              </div>
              <div v-show="!isPointHintModal" class="c-popup-body__footer">
                <div :class="{'btnBlock':true, '-noBg': isHelpModal, '-single': isNextGradeModal}">
                  <slot name="footer"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
  import {onMounted, computed} from "vue";
  import { useWorkStore } from '@/store/student/work_store';

  const workStore = useWorkStore()
  const props = withDefaults(
    defineProps<{
      modelValue?: boolean;
      isHelpModal?: boolean;
      modalPositionVertical?: boolean;
      isPointHintModal?: boolean;
      isNextGradeModal?: boolean;
      subject?: string;
      name?: string;
    }>(),
    {
      modelValue: false,
      isHelpModal: false,
      modalPositionVertical: false,
      isPointHintModal: false,
      isNextGradeModal: false,
      subject: "",
      name: '',
    }
  );

  const emit = defineEmits<{
    (e: 'close'): void,
    (e: 'close-layer'): void,
    (e: 'update:model-value', value: boolean),
  }>()

  onMounted(() => {
    window.addEventListener('scroll', () => {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    });
  })

  const modal = computed(() => {
    const body = document.body;
    if (props.modelValue) { // モーダルが開いたとき背景をスクロールした位置で固定にしてスクロールできないようする。
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}`;
    } else {
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
    return props.modelValue
  })

</script>
